import React from 'react'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { ButtonWithLoading } from '../FormsyHelperComponent'
import themesConfig from 'app/fuse-configs/themesConfig'

const createColor = (theme) => ({
  color: theme.palette.button.cancel.text,
  '&.MuiButton-root:hover': {
    backgroundColor: theme.palette.button.cancel.onHover.bg,
  },
  '&.MuiButton-text.MuiButton-root:active': {
    backgroundColor: theme.palette.button.cancel.onPress.bg,
  },
})

export const useStyles = makeStyles((theme) => ({
  labelDelete: {
    backgroundColor: themesConfig.default.palette.button.delete.bg,
    color: themesConfig.default.palette.button.delete.text,
    '&.MuiButton-root:hover': {
      backgroundColor: themesConfig.default.palette.button.delete.onHover.bg,
    },
    '&.MuiButton-text.MuiButton-root:active': {
      backgroundColor: themesConfig.default.palette.button.delete.onPress.bg,
    },
  },
  loading: createColor(theme),
}))

const DestructiveButton = ({ labelId, children, className, ...props }) => {
  const classes = useStyles()
  return (
    <ButtonWithLoading
      variant="text"
      className={clsx(classes.labelDelete, className, 'px-16')}
      CircularProp={{
        className: classes.loading,
      }}
      {...props}
    >
      {labelId ? <FormattedMessage id={labelId} /> : children}
    </ButtonWithLoading>
  )
}

export default DestructiveButton
